import React from 'react';
import i18n from 'i18next';

const FollowSuccessMessage = ({communityName}) => {
  const learnMoreLink = 'https://support.healthunlocked.com/customer/portal/articles/2944179-what-does-“following-a-community”-mean-';

  return (
    <span>
      {i18n.t("You're now a member of") + ' ' + communityName}. {' '}
      <a
        className='learn-more-link'
        href={learnMoreLink}
        target='_blank'
      >
        {i18n.t('Learn more')}
      </a>
    </span>
  );
};

export default FollowSuccessMessage;



// WEBPACK FOOTER //
// ./src/modules/community/shared/components/alert/followSuccessMessage.js